import { Repository } from '../../servics/httpsServics';

const controller = '/user-single-calls';

export function userAvailableService(data) {
  return Repository.post(controller+'/initialize', data);
}
